import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { JarwisService } from 'src/app/Services/jarwis.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';

@Component({
  selector: 'app-request-reset',
  templateUrl: './request-reset.component.html',
  styleUrls: ['./request-reset.component.scss']
})
export class RequestResetComponent implements OnInit {
  
  @ViewChild('canvas2', { static: true }) canvas2: ElementRef<HTMLCanvasElement>;
  answer: number;
  userText: any;
  output: any;
  refreshButton: any;
  realCaptcha: any;
  ctx: any;

  public showInfoContent: boolean = false;
  public forgotForm: FormGroup;
  public settings: Settings;
  constructor(private toastr: ToastrService, public appSettings: AppSettings, public fb: FormBuilder, public router: Router, private jarwis: JarwisService) {
    this.settings = this.appSettings.settings;
    this.forgotForm = this.fb.group({
      'email': [null, Validators.compose([Validators.required, Validators.email])],
      'captcha': [null]
    });
  }

  ngOnInit() {
    this.createCaptcha();
  }

  isSpace(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode == 32) {
      return false;
    }
    return true;
  }

  onSubmit(values) {
    if (!this.validate(values['captcha'])) {
      if (this.forgotForm.valid) {
        let tempEmail = this.forgotForm.controls.email.value;
        let lowerCaseEmail = tempEmail.toLowerCase();
        let encryptedEmail = btoa(lowerCaseEmail);
        values['email'] = encryptedEmail;
        values['captcha'] = btoa(this.forgotForm.controls.captcha.value+"Success");
        values['orgCaptcha'] = btoa(this.forgotForm.controls.captcha.value);
        this.jarwis.sendPasswordResetLink(values).subscribe(
          data => {
            if (data['type'] == 'success') {
              this.toastr.success(data['message']);
            } else {
              this.toastr.error(data['message'])
            }
            this.refreshCaptcha();
            this.forgotForm.controls.email.setValue(null);
          }
        );
      } else {
        this.forgotForm.reset();
        this.toastr.error('Please provide a valid email ID!');
      }
    } else {
      this.forgotForm.reset();
      this.toastr.error('Invalid Captcha! Please try again.');
      this.refreshCaptcha();
    }
  }

  ngAfterViewInit() {
    this.settings.loadingSpinner = false;
  }

  createCaptcha() {
    this.ctx = this.canvas2.nativeElement.getContext("2d");
    this.ctx.font = "bold 42px Roboto";
    this.ctx.fillStyle = "#111111";

    this.userText = document.getElementById('textBox');
    // this.submitButton = document.getElementById('submitButton');
    this.output = document.getElementById('output');
    this.refreshButton = document.getElementById('refreshButton');

    // alphaNums contains the characters with which you want to create the CAPTCHA
    let alphaNums = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    let emptyArr = [];

    // This loop generates a random string of 7 characters using alphaNums
    // Further this string is displayed as a CAPTCHA
    for (let i = 1; i <= 7; i++) {
      emptyArr.push(alphaNums[Math.floor(Math.random() * alphaNums.length)]);
    }
    this.realCaptcha = emptyArr.join('');
    this.ctx.fillText(emptyArr.join(''), 75, 75);
  }

  change(value: string) {
    return this.validate(value);
  }

  refreshCaptcha() {
    this.userText.value = "";
    let refreshArr = [];
    let alphaNums = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let j = 1; j <= 7; j++) {
      refreshArr.push(alphaNums[Math.floor(Math.random() * alphaNums.length)]);
    }
    this.ctx = this.canvas2.nativeElement.getContext("2d");
    this.ctx.clearRect(0, 0, 300, 150);
    this.realCaptcha = refreshArr.join('');
    this.ctx.fillText(refreshArr.join(''), 75, 75);
  }

  validate(value) {
    if (this.realCaptcha === value) {
      return 0;
    } else {
      return 1;
    }
  }

}
